import React from 'react';
import Text from '../../../Text';
import * as Styles from './styles';
export const PriceInfo = _ref => {
  let {
    children,
    mode
  } = _ref;
  if (!children) return null;
  return React.createElement(Styles.PriceInfo, {
    className: mode
  }, mode === 'vertical' && React.createElement(Text.Caption, {
    tag: "p",
    className: "price-info"
  }, children[0]), mode === 'horizontal' && children.map((information, idx) => React.createElement(Text.Caption, {
    tag: "p",
    className: "price-info",
    key: idx
  }, information)));
};